import * as React from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { colors } from "theme";
import styled from "styled-components";
import { DatePicker } from "@mui/x-date-pickers";
import calender from "assets/svgs/calenderIcon.svg";
import { Wrapper } from "components/core/BaseDropdown/styles";
import { Ptag } from "components/core/fonts";

export default function BaseDateInput({ formikProps, ...props }) {
  const [value, setValue] = React.useState();
  // const classes = useStyles();
  const { name, errors, touched, setFieldError, setTouched } = formikProps;
  React.useEffect(() => {
    if (formikProps?.values?.[name]) {
      const prev_value = dayjs(formikProps.values[name]);
      setValue(prev_value);
    } else {
      const initial_value = dayjs(formikProps.initialValues[name]);
      setValue(initial_value);
    }
  }, [formikProps?.values?.[name]]);
  const onChange = (e) => {
    setValue(e);
    setTouched({ ...formikProps.touched, [name]: true });
    if (dayjs(e).isValid) {
      formikProps.values[name] = dayjs(e).format("YYYY-MM-DD");
    }
  };

  const onError = (e) => {
    if (!touched[name]) return;
    if (e) {
      setFieldError(name, "*Please Enter a valid date.");
    } else {
      setFieldError(name, "");
    }
  };
  return (
    <Wrapper style={{ maxWidth: "100%" }}>
      {props.staticLabel && (
        <span id="static-label">
          <Ptag
            color={colors.primaryColor}
            fontSize="16px !important"
            marginBottom="10px"
          >
            {props.staticLabel}
          </Ptag>
        </span>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer
          components={["DateField", "DateField"]}
          sx={{ paddingTop: "0px" }}
        >
          {/* <DateField
          label={props.label}
          value={value}
          onChange={(e) => onChange(e)}
          format="DD/MM/YYYY"
          sx={{
            "& fieldset": {
              border: ` 1px solid ${colors.primaryColor}`,
              borderRadius: "10px",
            },
            "& input": {
              fontSize: "14px",
              fontWeight: "400",
            },
          }}
        /> */}
          <DatePicker
            label={props.label}
            value={value}
            onChange={(e) => onChange(e)}
            format="DD/MM/YYYY"
            minDate={props.onlyFutureDate ? dayjs() : ""}
            maxDate={props.onlyPastDate ? dayjs() : ""}
            // className={classes.datePicker}
            sx={{
              width: "100%",
              height: "48px",
              "& fieldset": {
                border: `none`,
                border: `1px solid ${colors.primaryColor}`,
                borderRadius: "10px",
                borderColor: ` ${colors.primaryColor} !important`,
              },
              "& input": {
                fontSize: "16px !important",
                padiding: "12.5px",
                fontWeight: "400",
              },
              ".MuiOutlinedInput-input": {
                padding: "12.5px",
                height: "",
              },
              ".MuiSvgIcon-root": {
                width: "1.8rem",
                height: "1.8rem",
                color: `${colors.primaryColor}`,
              },
              ".MuiIconButton-root": {
                padding: "14px",
              },
              ".Mui-error": {
                borderColor: "green",
              },
              ...(props.customSx || {}),
            }}
            slotProps={{
              layout: {
                sx: {
                  fontSize: "12px !important",
                  fontFamily: "Inter",
                  "& *": {
                    fontSize: "12px !important",
                  },
                },
              },
            }}
            onError={(e) => onError(e)}
          />
        </DemoContainer>
        {errors && errors[name] && touched && touched[name] && (
          <Error>{errors[name]}</Error>
        )}
      </LocalizationProvider>
    </Wrapper>
  );
}

const Error = styled.p`
  color: red;
  font-weight: 300;
  font-size: 10.4px !important;
  margin-left: 0.2rem;
  position: absolute;
  z-index: 9;
`;
